export default __webpack_public_path__ + "9c5dd4a0629b12ea1ff14a2aaf1e5076.png";